import styled from 'styled-components'
import { color, position, space } from 'styled-system'

const Bar = styled('hr')`
  border: 0;
  height: 1px;
  ${color};
  ${position};
  ${space};
  ${props =>
    props.text
      ? `
    position: relative;
    overflow: visible;
    ::before {
      content: "${props.text}";
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%,0);
      padding: 0 10px;
      height: 100%;
      overflow: hidden;
      background: white;
      color: transparent;
      font-weight: 500;
      font-size: 10px;
      letter-spacing: 0.1em;
    }
    ::after {
      content: "${props.text}";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      padding: 0 10px;
      font-weight: 500;
      font-size: 10px;
      letter-spacing: 0.1em;
      ${color};
    }
  `
      : ''}
}
`

Bar.defaultProps = {
  mx: '-20px',
  mt: '10px',
  mb: '20px'
}

Bar.displayName = 'Bar'

export default Bar
